<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.system_parlay")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-6.mb-1
                DatePicker
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.member_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="member_id"
                    :placeholder='$t("ui.member_id")'
                    v-model="member_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row.mb-2
              .col-sm-12.col-md-12.col-lg-10.col-xl-10.mb-1
                b-breadcrumb.bg-grey-transparent-3.p-l-10
                  b-breadcrumb-item.text-uppercase(
                    v-if="mode == 1 || mode == 2"
                    :text="line_member"
                    @click="redirectTo(0)"
                  )
                  b-breadcrumb-item.text-uppercase(
                    v-if="mode == 2"
                    :text="line_sys_id"
                    @click="redirectTo(1)"
                  )
              .col-sm-12.col-md-12.col-lg-10.col-xl-10(v-if="mode == 2 && data3 != null && data3.length > 0")
                label.label.bg-success.mr-1 {{ data3[0].total_accept }} {{ $t("ui.total_accepted") }}
                label.label.bg-danger.mr-1 {{ data3[0].total_reject }} {{ $t("ui.total_rejected") }}
                label.label.bg-warning.mr-1 {{ $t("ui.total_stake") }}: {{ $store.getters.getAccountCurrency }} {{ data3[0].sum_bet | currency }}
                label.label.bg-info.mr-1(v-if="data3[0].pending==0") {{ $t("ui.total_winlose") }}:  {{ $store.getters.getAccountCurrency }} {{ data3[0].sum_wl | currency }}
                label.label.bg-info.mr-1(v-else) {{ $t("ui.total_winlose") }}: -
            b-row
              .col-sm-12.col-md-8.col-lg-7.col-xl-8.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-10.col-xl-10
                b-table#tblList.table-sm.table-hover.table-bordered(v-if="mode == 0" striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="systemParlayList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(member_id)="row")
                    b-link(@click="getBetSystemParlay(row.item.member_id)") #[b {{ row.item.member_id.toUpperCase() }}]
                  template(v-slot:cell(currency)="row")
                    currency(:currency="row.item.currency")
                  template(v-slot:cell(bet_count)="row")
                    span #[b {{ row.item.bet_count }} ]
                  template(v-slot:cell(bet_member)="row")
                    span(:class="$helpers.getNumberClass(row.item.bet_member)") #[b {{ row.item.bet_member | currency }} ]
                b-table#tblList.table-sm.table-hover.table-bordered(v-if="mode == 1" striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :items="data1" :fields="fields1" :per-page="perPage" :filter="filter")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(system_parlay_id)="row")
                    b-link(@click="getBetSystemParlayBet(row.item)") {{ $t("ui.refno") }} #[b {{ row.item.system_parlay_id }}]
                  template(v-slot:cell(detail)="row")
                    span.mr-1 {{ row.item.total_match }} {{ $t("ui.match") }}
                    span.label.bg-black {{ $t("ui.details") }}
                    i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getMatch(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                  template(v-slot:row-details="row")
                    b-table#innerTable.table-sm(show-empty :items="data2" :fields="vDfields")
                      template(v-slot:cell(index)="row")
                        span {{ row.index + 1 }}
                      template(v-slot:cell(league_name)="row")
                        span {{ getName(0, row.item) }}
                      template(v-slot:cell(bet)="row")
                        span {{ $helpers.getBetDetail(row.item, getName(1, row.item), getName(2, row.item)) }}
                  template(v-slot:cell(bet_member)="row")
                    span(:class="$helpers.getNumberClass(row.item.bet_member)") #[b {{ row.item.bet_member | currency }} ]
                  template(v-slot:cell(created_on)="row")
                    span {{ $moment(row.item.created_on).format("YYYY-MM-DD HH:mm:ss") }}
                b-table#tblList.table-sm.table-hover.table-bordered(v-if="mode == 2" striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :items="data3" :fields="fields2" :per-page="perPage" :filter="filter")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(bet_id)="row")
                    span {{ $t("ui.refno") }} #[b {{ row.item.bet_id }}]
                  template(v-slot:cell(detail)="row")
                    span.mr-1 {{ $t("ui.mix_parlay") }}
                    span.mr-1 @ {{ row.item.odds_display }}
                    span.label.bg-black {{ $t("ui.details") }}
                    i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getParlayDetail(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                  template(v-slot:row-details="row")
                    b-table#innerTable.table-sm(show-empty :items="data4" :fields="vDfields1")
                      template(v-slot:cell(index)="row")
                        span {{ row.index + 1 }}
                      template(v-slot:cell(working_date)="row")
                        span {{ $moment(row.item.working_date).format("YYYY-MM-DD HH:mm:ss") }}
                      template(v-slot:cell(league_name)="row")
                        span {{ getParlayName(row.item.league_id, 0) }}
                      template(v-slot:cell(home_team_name)="row")
                        span(:class="row.item.home_giving == 1 ? 'text-danger' : 'text-info'") {{ getParlayName(row.item.match_id, 1) }}
                      template(v-slot:cell(away_team_name)="row")
                        span(:class="row.item.home_giving == 0 ? 'text-danger' : 'text-info'") {{ getParlayName(row.item.match_id, 2) }}
                      template(v-slot:cell(full_half)="row")
                        span {{ (row.item.full_half == 1) ? $t("ui.full_time") : $t("ui.half_time") }}
                      template(v-slot:cell(running_score)="row")
                        span {{ row.item.running_score ? row.item.running_score : '-' }}
                      template(v-slot:cell(status)="row")
                        template(v-if="isMMO")
                          span {{ $helpers.showWinStatusMMO(row.item) }}
                        template(v-else)
                          span {{ $helpers.showWinStatus(row.item) }}
                  template(v-slot:cell(bet_member)="row")
                    span(:class="$helpers.getNumberClass(row.item.bet_member)") #[b {{ row.item.bet_member | currency }} ]
                  template(v-slot:cell(winlose)="row")
                    span(:class="$helpers.getNumberClass(row.item.winlose)") #[b {{ row.item.winlose | currency }} ]




</template>

<script>
import { required } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton.vue";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import DatePicker from "@/library/DatePicker.vue";
import currency from "@/components/settings/currency.vue"

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    DatePicker,
    currency
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      mode: 0,
      member_id: null,
      line_member: null,
      line_sys_id: null,
      systemParlayList: [],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      matchParlay: [],
      leagueParlay: [],
      filter: null,
      sortBy: "member_id",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    };
  },
  validations: {},
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "member_id",
          label: this.$t("ui.member_id"),
          sortable: true,
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "currency",
          label: this.$t("ui.currency"),
          sortable: true,
          class: "align-middle text-center ",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        // {
        //   key: "bet_count",
        //   label: this.$t("ui.bet_count"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "align-middle text-white bg-dark-lighter",
        //   thStyle: {
        //     width: "15%"
        //   }
        // },
        {
          key: "bet_member",
          label: this.$t("ui.amount"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        }
      ]
    },
    fields1() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "system_parlay_id",
          label: this.$t("ui.id"),
          sortable: false,
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "detail",
          label: this.$t("ui.detail"),
          sortable: false,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "fold",
          label: this.$t("ui.fold"),
          sortable: false,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "combination",
          label: this.$t("ui.combination"),
          sortable: false,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "bet_member",
          label: this.$t("ui.amount"),
          sortable: false,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "created_on",
          label: this.$t("ui.created_on"),
          sortable: false,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        }
      ]
    },
    vDfields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "league_name",
          label: this.$t("ui.league_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "home_team_name",
          label: this.$t("ui.home_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "away_team_name",
          label: this.$t("ui.away_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet_type",
          label: this.$t("ui.bet_type"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet",
          label: this.$t("ui.bet"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "ball_display",
          label: this.$t("ui.ball"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "odds_display",
          label: this.$t("ui.odds_display"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "score",
          label: this.$t("ui.score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        }
      ]
    },
    fields2() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "bet_id",
          label: this.$t("ui.id"),
          sortable: false,
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "detail",
          label: this.$t("ui.detail"),
          sortable: false,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "bet_member",
          label: this.$t("ui.amount"),
          sortable: false,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "winlose",
          label: this.$t("ui.winlose"),
          sortable: false,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "bet_status",
          label: this.$t("ui.status"),
          sortable: false,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        }
      ]
    },
    vDfields1() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "working_date",
          label: this.$t("ui.date"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "league_name",
          label: this.$t("ui.league_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "home_team_name",
          label: this.$t("ui.home_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "away_team_name",
          label: this.$t("ui.away_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "full_half",
          label: this.$t("ui.match_time"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet_type",
          label: this.$t("ui.bet_type"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet",
          label: this.$t("ui.bet"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "odds_display",
          label: this.$t("ui.odds_display"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "payout_odds",
          label: this.$t("ui.payout"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "home_score",
          label: this.$t("ui.home_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "away_score",
          label: this.$t("ui.away_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "running_score",
          label: this.$t("ui.running_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    },
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    redirectTo: function(mode) {
      switch(mode) {
        case 0:
          this.mode = mode
          this.member_id = null
          this.systemParlayList = []
          this.submit()
          break
        case 1:
          this.mode = mode
          this.member_id = this.line_member
          this.data1 = []
          this.data2 = []
          this.getBetSystemParlay(this.member_id)
          break
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    getName: function(mode, match) {
      let name = ""

      switch(mode) {
        case 0:
          name = match["name_" + this.language] ? match["name_" + this.language] : match["name_en"]
          break
        case 1:
          name = match["home_name_" + this.language] ? match["home_name_" + this.language] : match["home_name_en"]
          break
        case 2:
          name = match["away_name_" + this.language] ? match["away_name_" + this.language] : match["away_name_en"]
          break
      }

      return name
    },
    submit: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let search_id = this.member_id
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("user/getSystemParlay", { search_id, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.clearTotal()
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.systemParlayList = response.data
                this.totalRows = response.data.length > 0 ? this.systemParlayList[0]["totalrows"] : 0
              } else {
                this.clearTotal()
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.clearTotal()
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    getBetSystemParlay(member_id) {
      let search_id = member_id
      let start_date = this.dateRange.startDate
      let end_date = this.dateRange.endDate
      let page_number = this.currentPage
      let page_size = this.perPage
      this.data1 = []
      this.mode = 1
      this.line_member = search_id
      this.$store
        .dispatch("user/getBetSystemParlay", { search_id, start_date, end_date, page_number, page_size })
        .then(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.data1 = response.data
            }
          }
        })
        .catch(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    getMatch(e) {
      if(e._showDetails) {
        this.data1.forEach(value => {
          this.$set(value, '_showDetails', false)
        })
        this.$set(e, '_showDetails', true)
      }
      let system_parlay_id = e.system_parlay_id
      this.data2 = []

      this.$store
        .dispatch("user/getBetSystemParlayMatch", { system_parlay_id })
        .then(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.data2 = response.data
            }
          }
        })
        .catch(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    getBetSystemParlayBet(item) {
      let system_parlay_id = item.system_parlay_id
      let member_id = item.member_id
      let page_number = this.currentPage
      let page_size = this.perPage
      this.data1 = []
      this.data2 = []
      this.data3 = []
      this.mode = 2
      this.line_sys_id = item.system_parlay_id
      this.$store
        .dispatch("user/getBetSystemParlayBet", { system_parlay_id, member_id, page_number, page_size })
        .then(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.data3 = response.data
            }
          }
        })
        .catch(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    getParlayDetail: function(item) {
      if(item._showDetails) {
        this.data3.forEach(value => {
          this.$set(value, '_showDetails', false)
        })
        this.$set(item, '_showDetails', true)
      }
      this.data4 = []
      let bet_id = item.bet_id
      let member_id = item.member_id
      this.$store
        .dispatch("user/getParlayDetail", { bet_id, member_id })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.data4 = response.data
              this.matchParlay = response.names.match
              this.leagueParlay = response.names.league
            }
          }
        })
        .catch(response => {
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    getParlayName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.leagueParlay.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.matchParlay.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    clearTotal() {
      this.$store.dispatch("user/setSelectedID", "")
      this.systemParlayList = []
      this.totalRows = 0
    }
  }
};
</script>

